module.exports = __webpack_public_path__ + "img/writing the classroom.b8cb3060.png";